import { ReactNode } from "react";

import {
  ScrollWrapper,
  SectionSidebar,
  SectionSidebarProps,
} from "./section-components";

export const IntakeSidebar = ({
  children,
  newUI,
  isPreview,
  ...props
}: SectionSidebarProps & {
  hideSidebar?: boolean;
  children?: ReactNode;
  newUI?: boolean;
  isPreview?: boolean;
}) => (
  <ScrollWrapper isPreview={isPreview} newUI={newUI}>
    {children}
    {(props.visibleSections.length > 1 || props.autoFillSection) && (
      <SectionSidebar {...props} />
    )}
  </ScrollWrapper>
);
